import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	SENTIMENT_CF_TYPE,
	ISSUE_FIELD_STRING_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggJSMSentimentToLegacyField: FieldTransformer<typeof SENTIMENT_CF_TYPE> = (
	node,
) => {
	if (node.type !== SENTIMENT_CF_TYPE) return undefined;

	return {
		...transformAggNodeToLegacyField(node),
		value: node.sentiment,
		schema: {
			configuration: null,
			custom: SENTIMENT_CF_TYPE,
			items: ISSUE_FIELD_STRING_CF_TYPE,
			renderer: PLAIN_TEXT,
			system: null,
			type: 'array',
		},
	};
};
